'use client'

import { useTranslation } from '@shared/config/i18n'

import { Typography } from '@podo-app/design-system-temp'

const OPEN_IN_APP_HREF = '/open-in-app/home'

export const AppOpenButton = () => {
  const t = useTranslation()

  const handleOpenApp = () => {
    window.location.href = OPEN_IN_APP_HREF
  }

  return (
    <button className="bg-[#B5FD4C] py-[3px] px-3 rounded-[14px] h-7" onClick={handleOpenApp}>
      <Typography size="body2" className="font-bold">
        {t('native.appInstallBanner.openApp')}
      </Typography>
    </button>
  )
}
